import { useMutation, useQueryClient } from '@tanstack/react-query';

// The extend-custody WRITE («Ampliar custodia»), and the panel's FIRST PARAMETERIZED mutation: its
// four siblings are all `mutate()` with no variable, this one carries the chosen day. The extend fn
// is injected (DI, MSW-testable). retry: false — a WRITE that moves a deadline must never be
// silently re-sent. Invalidations are identical to the siblings': the detail by exact key (so the
// «Expira la recogida» row and the «Ampliada» badge refetch, data-driven), the deliveries
// list and the three device-keyed reads by PREFIX, since this hook knows neither the userId, the
// boxId nor the lockId. The codes are in that set because a write can end up moving them, and a
// stale sequence is one the agent reads out loud.
export function useExtendCustody(
  id: string,
  extendCustody: (id: string, expirationDate: string) => Promise<void>,
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (expirationDate: string) => extendCustody(id, expirationDate),
    retry: false,
    // Fire-and-forget: do NOT return the promise. Returning it makes TanStack await the refetch
    // before the mutation settles, which would hide the refetch skeleton the caller drives off the
    // query's own fetching state.
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['delivery-detail', id] });
      void queryClient.invalidateQueries({ queryKey: ['user-deliveries'] });
      // …and the same list reached from a building's tab: same rows, other entry point.
      void queryClient.invalidateQueries({ queryKey: ['location-deliveries'] });
      void queryClient.invalidateQueries({ queryKey: ['locker-log'] });
      void queryClient.invalidateQueries({ queryKey: ['box-status'] });
      void queryClient.invalidateQueries({ queryKey: ['lock-codes'] });
    },
  });
}
